module.exports = __webpack_public_path__ + "img/jobs.c361268b.svg";